var map = {
	"./1mg-logo-vector.svg": 446,
	"./200332.svg": 4699,
	"./347286.png": 1431,
	"./Adidas-Logo..svg": 9743,
	"./AirAsia-Logo..svg": 7095,
	"./Boat-logo-Black.svg": 8143,
	"./Cleartrip Logo.svg": 3590,
	"./Clovia_logo_PNG1.png": 2232,
	"./Dell_Logo.svg": 2958,
	"./Dyson_company-Logo.svg": 3620,
	"./Fastrack_eyeware-logo.png": 3253,
	"./Fitspire-logo-TM-Copy-1024x333.png": 5462,
	"./GIVA-logo-black-1024x442.png": 6992,
	"./IGP_(logo).png": 5062,
	"./Klook-New.svg": 4324,
	"./Lakme Logo.svg": 6806,
	"./Manyavar.svg": 5956,
	"./Myntra_logo.png": 9816,
	"./OnePlus.svg": 9555,
	"./Portronics.svg": 7444,
	"./Puma_brand.svg": 780,
	"./Samsung-Logo.wine.svg": 5901,
	"./Snapdeal-Logo.wine.svg": 3950,
	"./TWW_backend_shopify_c971c564-402c-41d5-82fc-8bba52dfd269.png": 6747,
	"./Tata_Cliq_logo (1).svg": 3289,
	"./Tripadvisor_Logo_circle-green_vertical-lockup_registered_RGB.svg": 1434,
	"./apple.svg": 1523,
	"./facescanada.png": 5547,
	"./fastrack.png": 5092,
	"./flipkart.svg": 2522,
	"./goibibo-logo.svg": 1546,
	"./ihg-intercontinental-hotels-group-vector-logo.svg": 8251,
	"./ixigo-new-logo.png": 870,
	"./lancome-3-logo-png-transparent.png": 4847,
	"./lenovo.svg": 2876,
	"./livpure-seeklogo.com.svg": 125,
	"./make-my-trip.svg": 6258,
	"./mamaearth.svg": 5819,
	"./new-fnplogo.png": 719,
	"./nike-3-logo-svg-vector.svg": 3001,
	"./noise-seeklogo.com.svg": 1114,
	"./nykaa-1.svg": 1969,
	"./nykaa_logo.svg": 4195,
	"./panasonic.svg": 9137,
	"./pepperfry.svg": 7982,
	"./shoppersstop.png": 915,
	"./tanishq-seeklogo.com.svg": 7440,
	"./titaneyeplus.svg": 8496,
	"./van-heusen-1.svg": 8219,
	"./vero-moda.svg": 7457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2451;